export const msgAlreadySubscribed = 'Email address is already subscribed.'
export const msgEmailInvalid = 'Email address is invalid.'
export const msgEmptyField = 'Please enter an email address.'
export const msgRequestError = 'Something went wrong. Please try again.'
export const msgSuccess = 'Thank you for subscribing!'
export const msgTooManyRecentRequests = 'Too many recent signup requests.'
